module.exports = __webpack_public_path__ + "static/media/close-k-30.5ecc2c0f.png";